
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  twitterCard?: 'summary' | 'summary_large_image';
  noIndex?: boolean;
  structuredData?: Record<string, any> | Record<string, any>[];
}

const SEO = ({
  title = 'Dr.Cash - Soluções financeiras para clínicas de saúde',
  description = 'A Dr.Cash cuida da saúde financeira da sua clínica com boleto parcelado e antecipação de recebíveis. Receba em 48h, parcele em até 24x.',
  keywords = 'financiamento clínica médica, boleto parcelado saúde, antecipação recebíveis',
  canonical,
  ogImage = '/lovable-uploads/599d1440-1447-4c6c-82e1-73e69c25bc5b.png',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noIndex = false,
  structuredData,
}: SEOProps) => {
  // Ensure canonical URLs use the root domain
  const baseUrl = 'https://drcash.com.br';
  
  // Fix canonical URL
  const fixedCanonical = canonical 
    ? (canonical.startsWith('http') ? canonical : `${baseUrl}${canonical.startsWith('/') ? canonical : `/${canonical}`}`)
    : typeof window !== 'undefined' 
      ? `${baseUrl}${window.location.pathname}`
      : `${baseUrl}/`;
  
  // Fix image URL
  const fixedOgImage = ogImage.startsWith('http') 
    ? ogImage 
    : `${baseUrl}${ogImage.startsWith('/') ? ogImage : `/${ogImage}`}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={fixedCanonical} />
      
      {/* SPA Specific Meta Tags for Crawlers */}
      <meta name="fragment" content="!" />
      <meta name="renderer" content="webkit" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fixedCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fixedOgImage} />
      <meta property="og:site_name" content="Dr.Cash" />
      <meta property="og:locale" content="pt_BR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:site" content="@DrCashBR" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fixedOgImage} />
      
      {/* Structured Data */}
      {structuredData && Array.isArray(structuredData) ? (
        structuredData.map((data, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        ))
      ) : structuredData ? (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      ) : null}
    </Helmet>
  );
};

export default SEO;
